import { Navigate } from 'react-router-dom'

import { useQuery } from '@apollo/client'
import { EngagementRedirectToRouteDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'

import { useEngagementContext } from 'modules/engagement/hooks/useEngagementContext'
import engagementAuthorization from 'modules/engagement/lib/authorization'

const RedirectToRoutePage = () => {
  const { data, loading } = useQuery(EngagementRedirectToRouteDocument)
  const { moduleAvailabilities, enpsInstalled } = useEngagementContext()
  const { employee: currentEmployee } = useCurrentSession()
  const can = engagementAuthorization({ moduleAvailabilities, currentEmployee })
  const { navigation } = useNavigation()

  if (loading) {
    return
  }

  const buildUrl = () => {
    if (data?.engagement._policies.seePulseDashboard.can) {
      return navigation.engagement.pulse.fullPath()
    }

    if (can.seeSurveys) {
      return navigation.engagement.surveys.fullPath()
    }

    if (can.seeEnps && enpsInstalled) {
      return navigation.engagement.enps.fullPath()
    }

    if (can.seeInsights) {
      return navigation.engagement.insights.fullPath()
    }

    return navigation.dashboard.fullPath()
  }

  return <Navigate to={buildUrl()} />
}

export default RedirectToRoutePage
